<template>
  <div>
    <!-- <div class="topBacBox" v-if="isajaxShow">
			<div class="activityTextBox">
				<img src="@/assets/activity/activityText.png" alt="" />
			</div>
			<div class="activityBox">
				<img src="@/assets/activity/activityBag.png" alt="" />
			</div>
		</div> -->
    <div class="touristActivityBox">
      <!-- <div class="title-wrap">
				<div class="title-one">{{ activityObj.Name }}</div>
				<div class="title-two">{{ activityObj.SubName }}</div>
			</div> -->
      <div
        class="activity-wrap"
        v-if="activityList[0]"
        @click.stop="handelGoActivityList()"
      >
        <vue-seamless-scroll
          v-if="activityList.length > 6"
          class="seamless-scroll"
          :data="activityList"
          :class-option="activityOptions"
        >
          <div class="content-wrap">
            <div
              class="cotent-item-wrap"
              v-for="(item, index) in activityList"
              :key="index"
            >
              <div class="content-item" @click.stop="handleIsLogin(item)">
                <div class="content-img-wrap">
                  <img class="avatar-image" :src="item.AutoPartsPic1" />
                </div>
                <div class="inform-wrap">
                  <div class="name-wrap">{{ item.AutoPartsName }}</div>
                  <div class="vehicle-wrap">{{ item.VehicleName }}</div>
                  <div class="price-wrap">
                    <span class="activity-price">￥{{ item.ActivePrice }}</span>
                    <span class="original-price">{{ item.Price }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vue-seamless-scroll>

        <el-dialog
          custom-class="sg-login-dialog"
          :visible.sync="dialogVisible"
          title="请先登录"
          width="400px"
        >
          <login @closeLoginDialog="dialogVisible = false"></login>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import Login from "@/components/Login";
import vueSeamlessScroll from "vue-seamless-scroll";
import { TopActiveUnLogin, TopActive } from "@/api/merchant/dashboard";
import { mapGetters } from "vuex";
export default {
  components: {
    vueSeamlessScroll,
    Login,
  },
  data() {
    return {
      isajaxShow: false,
      dialogVisible: false,
      activityList: [],
      activityObj: {},
      activityOptions: {
        limitMoveNum: 6,
        direction: 2,
        singleWidth: 236,
      },
    };
  },
  computed: {
    ...mapGetters([
      "token",
    ]),
  },
  created() {
    if (!this.token) {
      TopActiveUnLogin({}).then((res) => {
        console.log(res);
        // this.activityObj = res
        this.isajaxShow = true;
        this.activityList = res.list;
      });
    } else {
      TopActive({}).then((res) => {
        console.log(res);
        // this.activityObj = res
        this.isajaxShow = true;
        this.activityList = res.list;
      });
    }
  },
  methods: {
    handleLogin() {
      this.dialogVisible = true;
    },
    handelGoActivityList() {
      if (!this.token) {
        // this.handleLogin()
        // console.log(999999999)

        return;
      } else {
        this.$router.push("/activity");
      }
    },
    handleIsLogin(item) {
      if (!this.token) {
        this.handleLogin();
        console.log(999999999);
        // return true;
      } else {
        this.handelGo(item);
      }
    },
    handelGo(e) {
      this.$router.push({
        path: `/parts-detail/?MctCode=${e.MctCode}&BarCode=${e.BarCode}&WhId=${
          e.WhId
        }&WhbId=${e.WhbId}&list=${true}`,
        // 传递的参数集合
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.topBacBox {
  position: relative;
  width: 100%;
  height: 135px;
  // background: pink;

  .activityBox {
    position: absolute;
    top: -80px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 2;
    width: 1144px;
    img {
      width: 100%;
      height: auto;
    }
  }
  .activityTextBox {
    position: absolute;
    top: -70px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 344px;
    z-index: 4;
    img {
      width: 100%;
      height: auto;
    }
  }
}
.touristActivityBox {
  position: relative;
  // background: pink;
  height: auto;
  width: 100%;
}
.title-wrap {
  display: flex;
  align-items: center;
  padding-left: 23px;

  .title-one {
    font-size: 30px;
    font-weight: 700;
    color: rgba(255, 255, 255, 1);
  }
  .title-two {
    height: 33px;
    opacity: 1;
    background: linear-gradient(
      180deg,
      rgba(33, 212, 253, 1) 0%,
      rgba(183, 33, 255, 1) 100%
    );
    font-size: 20px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    border-radius: 25px;
    padding: 0 10px;
    margin-left: 12px;
  }
}
.activity-wrap {
  // margin-top: 145px;
  border-radius: 10px;
  background: rgba(254, 118, 72, 1);
  height: 470px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // padding: 0 18px 15px;
  cursor: pointer;
  background: url("http://www.suguangapi.com:6001/API/File/Get?MCTCode=XSZ&FileName=PCOMS_ActivityIcon.png");
  .seamless-scroll {
    // width: 235px*6;
    padding-left: 16px;
    padding-top: 155px;
    height: 285px;

    overflow: hidden;
    // padding: 0 15px;
    .content-wrap {
      display: flex;
      .cotent-item-wrap {
        // margin: 0 15px;
        width: 220px;
        margin-right: 16px;
        height: 285px;
        background-color: white;
        border-radius: 10px;
        .content-item {
          cursor: pointer;
          padding: 12px;
          .content-img-wrap {
            margin-bottom: 9px;
            .avatar-image {
              width: 100%;
              height: 150px;
              object-fit: cover;
            }
          }
          .inform-wrap {
            .name-wrap {
              height: 24px;
              line-height: 24px;
              font-size: 16px;
              font-weight: 500;
              color: rgba(56, 56, 56, 1);
            }
            .vehicle-wrap {
              font-size: 12px;
              font-weight: 400;
              color: rgba(56, 56, 56, 1);
              margin-bottom: 11px;
              height: 36px;
            }
            .price-wrap {
              height: 36px;
              .activity-price {
                font-size: 24px;
                font-weight: 700;
                color: rgba(254, 118, 72, 1);
              }
              .original-price {
                margin-left: 5px;
                font-size: 10px;
                font-weight: 400;
                text-decoration-line: line-through;
                color: rgba(128, 128, 128, 1);
              }
            }
          }
        }
      }
    }
  }
}
</style>
